module.exports = __webpack_public_path__ + "static/media/news2.aaca475e.png";